import { render, staticRenderFns } from "./booking-parcel-details.vue?vue&type=template&id=e0742bd0"
import script from "./booking-parcel-details.vue?vue&type=script&lang=js"
export * from "./booking-parcel-details.vue?vue&type=script&lang=js"
import style0 from "./booking-parcel-details.vue?vue&type=style&index=0&id=e0742bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports